export * from "./Box";
export * from "./Text";
export * from "./Spinner";
export * from "./Icon";
export * from "./Divider";
export * from "./Input";
export * from "./TextArea";
export * from "./LinearGradient";

export const isWeb = true;
export const isNative = false;
